"use client"
import { useEffect } from "react"
import { isUserAdmin } from "../../utils/auth"
import { useNavigate } from "react-router-dom"
import NewUserForm from "../../components/NewUserForm/NewUserForm"

const UserForm = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isUserAdmin()) {
      navigate("/");
    }
  }, [])

  return (
    <>
      <NewUserForm />
    </>
  )
}

export default UserForm;